module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dropFile":"Drop sheet to update fields"}}')
  delete Component.options._Ctor
}
